import React from 'react';
import { Trans } from '@lingui/macro';
import { FormattedMarkdown } from '@qover/react-intl';

export default {
  title: <FormattedMarkdown id="faq.title" />,
  doc1: <Trans id="faq.doc1" />,
  doc2: <Trans id="faq.doc2" />,
  doc3: <Trans id="faq.doc3" />,
  complaints: <Trans id="faq.complaints" />,
  conflictsOfInterestPolicy: <Trans id="faq.conflictsOfInterestPolicy" />,
  fullFaqLink: <Trans id="faq.fullFaqLink" />,
  legalNotice: <Trans id="faq.legalNotice" />,
  others: <Trans id="faq.others.title" />,
};
